import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Product } from '../../../models/product.model';
import {
  BRAND,
  CATEGORY,
  PROGRAM,
  ITEM_TYPE,
  CHANNEL,
} from '../../../constants/filter-types';
import { Router } from '@angular/router';
import { PageService } from '../../../services/page.service';

const linkedTypes = [BRAND, CATEGORY, PROGRAM, ITEM_TYPE, CHANNEL];

@Component({
  selector: 'product-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ProductDetailsComponent implements OnInit {
  @Input()
  public product: Product;

  public isOpen = false;

  constructor(
    private router: Router,
    private pageService: PageService
  ) {}

  ngOnInit() {}

  expandDrawer(e) {
    this.isOpen = !this.isOpen;
    e.preventDefault();
  }

  getSkus() {
    const skuArray = this.product.skus.map((s) => s.getDisplaySkuID());
    if (skuArray.length > 1) {
      return `<span><strong>SKUS#</strong> ${skuArray.join(', ')}</span>`;
    } else {
      return `<span><strong>SKU#</strong> ${skuArray}</span>`;
    }
  }

  get vendorLabel(): string {
    if (!this.product) {
      return '';
    }

    return this.product.getVendor();
  }

  isLink(key: string) {
    return linkedTypes.includes(key);
  }

  navigateTo(type: string, value: string) {
    const path = this.product.rootPath;
    this.pageService.preselectedFilter = { path, type, value };
    this.router.navigate([path]);
    return false;
  }
}
